import React from "react";
import {ReactSession} from "react-client-session";
import VariabiliGlobali from "../../Back/VariabiliGlobali";
import axios from "axios";
import {Button, Checkbox, Collapse, FormLabel, Grid, MenuItem, Select, TextField} from "@mui/material";

class FiltriArticoliINV extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            descrizione: props.descrizione,
            marca: props.marca,
            reparto: props.reparto,
            promo: props.promo,
            idpromo: props.idpromo,
            repartiArr: [],
            open: false,
            testoFiltriArticoli: "Mostra filtri articoli"
        }
        this.idmagazzino = ReactSession.get("idmagazzino");
    }

    componentDidMount() {
        this.handleChange = this.handleChange.bind(this);
        this.chiediReparti();
    }

    chiediReparti() {
        const params = new URLSearchParams();
        params.append('idmagazzino', this.idmagazzino);
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        }
        const url = VariabiliGlobali.indirizzoIP + VariabiliGlobali.porta + '/controllonegozi/dammiReparti';
        axios.post(url, params, config)
            .then((response) => {
                this.setState({repartiArr: response.data})
            })
            .catch((error) => {
                console.log('Errore: ' + error);
                alert(JSON.stringify(error))
            })
    }

    resetta() {
        this.setState({descrizione: ""})
        this.setState({marca: ""})
        this.setState({reparto: "0"})
        this.setState({promo: "0"})
        this.props.resettaFiltri();
    }

    handleChange(event, provenienza) {
        if (provenienza === 'descrizione') {
            this.props.handleChangeArticolo(event.target.value, this.state.marca, this.state.reparto, this.state.promo, this.props.arrVAR, this.state.idpromo);
            this.setState({descrizione: event.target.value});
        }
        if (provenienza === 'marca') {
            this.props.handleChangeArticolo(this.state.descrizione, event.target.value, this.state.reparto, this.state.promo, this.props.arrVAR, this.state.idpromo);
            this.setState({marca: event.target.value});
        }
        if (provenienza === 'idpromo') {
            this.props.handleChangeArticolo(this.state.descrizione, this.state.marca, this.state.reparto, this.state.promo, this.props.arrVAR, event.target.value);
            this.setState({idpromo: event.target.value});
        }
        if (provenienza === 'reparto') {
            this.props.handleChangeArticolo(this.state.descrizione, this.state.marca, event.target.value, this.state.promo, this.props.arrVAR, this.state.idpromo);
            this.setState({reparto: event.target.value});
        }
        if (provenienza === 'promo') {
            this.props.handleChangeArticolo(this.state.descrizione, this.state.marca, this.state.reparto, event.target.value, this.props.arrVAR, this.state.idpromo);
            this.setState({promo: event.target.value});
        }
        if (provenienza === 'btnOpen') {
            this.setState({open: !this.state.open})
            if (this.state.open.toString() !== "true") {
                this.setState({testoFiltriArticoli: "Nascondi filtri articoli"})
            } else {
                this.setState({testoFiltriArticoli: "Mostra filtri articoli"})
            }
        }
        if (provenienza === 'arrVAR0') {
            let arrV = this.props.arrVAR;
            arrV[0] = arrV[0] !== true;
            this.props.handleChangeArticolo(this.state.descrizione, this.state.marca, this.state.reparto, this.state.promo, arrV, this.state.idpromo);
        }
        if (provenienza === 'arrVAR1') {
            let arrV = this.props.arrVAR;
            arrV[1] = event.target.value;
            this.props.handleChangeArticolo(this.state.descrizione, this.state.marca, this.state.reparto, this.state.promo, arrV, this.state.idpromo);
        }
        if (provenienza === 'arrVAR3') {
            let arrV = this.props.arrVAR;
            arrV[3] = event.target.value;
            this.props.handleChangeArticolo(this.state.descrizione, this.state.marca, this.state.reparto, this.state.promo, arrV, this.state.idpromo);
        }
        if (provenienza === 'arrVAR4') {
            let arrV = this.props.arrVAR;
            arrV[4] = event.target.value;
            this.props.handleChangeArticolo(this.state.descrizione, this.state.marca, this.state.reparto, this.state.promo, arrV, this.state.idpromo);
        }
        if (provenienza === 'arrVAR5') {
            let arrV = this.props.arrVAR;
            arrV[5] = event.target.value;
            this.props.handleChangeArticolo(this.state.descrizione, this.state.marca, this.state.reparto, this.state.promo, arrV, this.state.idpromo);
        }
        if (provenienza === 'arrVAR6') {
            let arrV = this.props.arrVAR;
            arrV[6] = event.target.value;
            this.props.handleChangeArticolo(this.state.descrizione, this.state.marca, this.state.reparto, this.state.promo, arrV, this.state.idpromo);
        }
        if (provenienza === 'arrVAR7') {
            let arrV = this.props.arrVAR;
            arrV[7] = event.target.value;
            this.props.handleChangeArticolo(this.state.descrizione, this.state.marca, this.state.reparto, this.state.promo, arrV, this.state.idpromo);
        }
        if (provenienza === 'arrVAR8') {
            let arrV = this.props.arrVAR;
            arrV[8] = event.target.value;
            this.props.handleChangeArticolo(this.state.descrizione, this.state.marca, this.state.reparto, this.state.promo, arrV, this.state.idpromo);
        }
        if (provenienza === 'arrVAR9') {
            let arrV = this.props.arrVAR;
            arrV[9] = event.target.value;
            this.props.handleChangeArticolo(this.state.descrizione, this.state.marca, this.state.reparto, this.state.promo, arrV, this.state.idpromo);
        }

    }

    getNomiReparti = function () {
        return this.state.repartiArr.map((el, i) =>
            <MenuItem value={el.idreparto}>{el.nome}</MenuItem>
        )
    }

    render() {

        return (
            <div>
                <Button variant="contained" onClick={(e) => this.handleChange(e, "btnOpen")}>
                    {this.state.testoFiltriArticoli}
                </Button>
                <Collapse in={this.state.open}>
                    <Grid container direction={"column"} spacing={3}>
                        <Grid item>
                            <Grid container direction={"row"} spacing={3}>
                                <Grid item>
                                    <TextField autoFocus
                                               label="Descrizione"
                                               value={this.state.descrizione}
                                               defaultValue={this.state.descrizione}
                                               onChange={(e) => this.handleChange(e, "descrizione")}/>

                                </Grid>
                                <Grid item>
                                    <TextField autoFocus
                                               label="Marca"
                                               value={this.state.marca}
                                               defaultValue={this.state.marca}
                                               onChange={(e) => this.handleChange(e, "marca")}/>

                                </Grid>
                                <Grid item>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="filtroRep"
                                        value={this.state.reparto}
                                        label=''
                                        onChange={(e) => this.handleChange(e, "reparto")}>
                                        <MenuItem value={'0'}>Scelta reparto</MenuItem>
                                        {this.getNomiReparti()}
                                    </Select>
                                </Grid>
                                <Grid item>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="filtroRep"
                                        value={this.state.promo}
                                        label=''
                                        onChange={(e) => this.handleChange(e, "promo")}>
                                        <MenuItem value={'0'}>Scelta promo</MenuItem>
                                        <MenuItem value={'1'}>Solo articoli in promo</MenuItem>
                                        <MenuItem value={'2'}>Escludi articoli in promo</MenuItem>
                                        <MenuItem value={'3'}>Escludi articoli promozione specifica:</MenuItem>
                                        <MenuItem value={'4'}>Solo promozione specifica:</MenuItem>

                                    </Select>
                                </Grid>
                                <Grid item>
                                    <TextField autoFocus
                                               label="ID Promo: "
                                               value={this.state.idpromo}
                                               defaultValue={this.state.idpromo}
                                               onChange={(e) => this.handleChange(e, "idpromo")}/>

                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container direction="row" spacing={3}>
                                <Grid item>
                                    <FormLabel component="legend">
                                        <Checkbox
                                            value={this.props.arrVAR[0]}
                                            onChange={(e) => this.handleChange(e, "arrVAR0")}
                                        />
                                        Articoli sottoscorta
                                    </FormLabel>
                                </Grid>
                                <Grid item visibility={"hidden"}>
                                    <TextField autoFocus
                                               label="ID Fornitore"
                                               value={this.props.arrVAR[4]}
                                               defaultValue={this.props.arrVAR[4]}
                                               onChange={(e) => this.handleChange(e, "arrVAR4")}/>

                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container direction="row" spacing={3}>
                                <Grid item>
                                    <TextField autoFocus
                                               label="ID Scheda"
                                               value={this.props.arrVAR[7]}
                                               defaultValue={this.props.arrVAR[7]}
                                               onChange={(e) => this.handleChange(e, "arrVAR7")}/>

                                </Grid>
                                <Grid item>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="filtroRep"
                                        value={this.props.arrVAR[8]}
                                        label=''
                                        onChange={(e) => this.handleChange(e, "arrVAR8")}>
                                        <MenuItem value={'0'}>Uguale</MenuItem>
                                        <MenuItem value={'1'}>Maggiore</MenuItem>
                                        <MenuItem value={'2'}>Maggiore o uguale</MenuItem>
                                        <MenuItem value={'3'}>Minore</MenuItem>
                                        <MenuItem value={'4'}>Minore o uguale</MenuItem>
                                    </Select>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container direction="row" spacing={3}>
                                <Grid item>
                                    <TextField autoFocus
                                               label="EAN"
                                               value={this.props.arrVAR[9]}
                                               defaultValue={this.props.arrVAR[9]}
                                               onChange={(e) => this.handleChange(e, "arrVAR9")}/>

                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container direction="row" spacing={3}>
                                <Grid item>
                                    <TextField autoFocus
                                               label="Codice interno"
                                               value={this.props.arrVAR[5]}
                                               defaultValue={this.props.arrVAR[5]}
                                               onChange={(e) => this.handleChange(e, "arrVAR5")}/>

                                </Grid>
                                <Grid item>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="filtroRep"
                                        value={this.props.arrVAR[6]}
                                        label=''
                                        onChange={(e) => this.handleChange(e, "arrVAR6")}>
                                        <MenuItem value={'0'}>Uguale</MenuItem>
                                        <MenuItem value={'1'}>Diverso</MenuItem>
                                    </Select>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container direction={"row"} spacing={3}>
                                <Grid item>
                                    <TextField m={3}
                                               id="startDate"
                                               label="Data carico"
                                               type="date"
                                               name="startDate"
                                               value={this.props.arrVAR[1]}
                                               defaultValue={this.props.arrVAR[1]}
                                               onChange={(e) => this.handleChange(e, "arrVAR1")}
                                               sx={{width: 220}}
                                               InputLabelProps={{
                                                   shrink: true,
                                               }}
                                    />
                                </Grid>
                                <Grid item>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="filtroRep"
                                        value={this.props.arrVAR[3]}
                                        label=''
                                        onChange={(e) => this.handleChange(e, "arrVAR3")}>
                                        <MenuItem value={'0'}>Uguale</MenuItem>
                                        <MenuItem value={'1'}>Maggiore</MenuItem>
                                        <MenuItem value={'2'}>Maggiore o uguale</MenuItem>
                                        <MenuItem value={'3'}>Minore</MenuItem>
                                        <MenuItem value={'4'}>Minore o uguale</MenuItem>
                                    </Select>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container direction={"row"} spacing={3}>
                                <Grid item>
                                    <Button variant="outlined" onClick={(e) => this.resetta()}>Resetta filtri</Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Collapse>
            </div>

        )

    }
}

export default FiltriArticoliINV

export function dammiArticoli(descrizione, marca, reparto, promo, arrVAR, idnegozio, idpromo) {
    return new Promise(async function (resolve, reject) {
        const params = new URLSearchParams();
        let idmagazzino = ReactSession.get("idmagazzino");
        params.append('idmagazzino', idmagazzino);
        params.append('descrizione', descrizione);
        params.append('marca', marca);
        params.append('reparto', reparto);
        params.append('promo', promo);
        params.append('arrVAR', JSON.stringify(arrVAR));
        params.append('idnegozio', idnegozio)
        params.append('idpromo', idpromo)

        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        }

        const url = VariabiliGlobali.indirizzoIP + VariabiliGlobali.porta + '/controllonegozi/dammiIDArticoli';
        await axios.post(url, params, config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                resolve("(0)");
            })

    })
}
